<template>
  <div class="col-12">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-10 col-lg-6">
        <div class="row text-center ml-5">
          <div class="mb-5">
            <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;" alt="">
          </div>
          <h3 class="ui inverted purple text"><strong>Upload Documents</strong></h3>
          <p class="text-muted fw-light mt-4">Please provide the documents indicated below:</p>
          <p>Copy of valid National ID or Passport, Proof of residence, Passport sized photo.</p>
          <small class="text-muted">To avoid delays, make sure your documents are clear.</small>
        </div>
        <div class="ui fitted divider mt-2"></div>
      </div>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-3">
      <div class="col-11 col-lg-9">
        <form v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="uploadArrayFilesSSO">
          <div class="row">
            <div class="col d-flex align-items-center">
              <a-select @change="startImageUpload" placeholder="Choose a document type" allowClear style="width: 100%">
                <a-select-option v-for="fileType of model.fileTypes" :key="fileType.label" :value="fileType.label">
                  {{ fileType.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <br />
          <a-upload-dragger v-if="showFileUploader" name="file" :before-upload="beforeUpload"
            @change="storeImageUpload">
            <p class="ant-upload-drag-icon">
              <InboxOutlined class="tn-text-gold" />
            </p>
            <p class="ant-upload-text">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint">You can upload multiple files at once</p>
          </a-upload-dragger>
          <div v-if="model.files.length > 0">
            <div class="row mt-5">
              <p class="col-3 h6">Doc Type</p>
              <p class="col-4 h6">File name</p>
              <p class="col-2 h6">Size</p>
              <p class="col-1 h6">Preview</p>
              <p class="col-1 h6"></p>
            </div>
            <div v-for="file of model.files" :key="file.docType" class="row border-top mt-1 pt-1">
              <div class="col-3">{{ file.docType }}</div>
              <div class="col-4">{{ file.file.name }}</div>
              <div class="col-2">{{ (file.file.size / 1028).toFixed(2) }} KB</div>
              <div class="col-2" style="cursor:pointer;" @click="showModalD(file.file)">
                <i class="eye icon"></i>
              </div>
              <div class="col-1" style="cursor:pointer;" @click="removeItem(file)">
                <i class="trash icon"></i>
              </div>
            </div>
          </div>
          <div v-if="showModal">
            <div class="modal-overlay">
              <div class="modal-content">
                <template v-if="isPdf(fileType)">
                  <object :data="filePreviewUrl" type="application/pdf" width="100%" height="500px">
                    <p>PDF Preview not available</p>
                  </object>
                </template>
                <template v-else-if="isImage(fileType)">
                  <img :src="filePreviewUrl" alt="Image Preview" />
                </template>
                <button @click="hideModal">Close Preview</button>
              </div>
            </div>
          </div>
          <div v-if="!areFilesUploadedValid" class="text-danger mt-4">{{ missingFile }}</div>
          <div class="ui purple floating message m-4">
            <div class="mb-2">
              <div class="header">
                <input type="checkbox" id="checkbox" v-model="isChecked">
                <label for="checkbox" style="color: #000;">Please confirm your agreement by selecting the box above
                  after you have
                  thoroughly read and fully understood the terms and conditions outlined below.</label>
                <div class="mt-3">
                  <div> &nbsp;</div>
                  <div> Please note that in order to comply with laid down RBZ guidelines your application will be <span
                      style="color: red;">Declined</span> if the following conditions are not met.</div>
                </div>
              </div>
              <ul class="list">
                <li>The proof of residence is dated within the last 3 months from the current month.</li>
                <li>The inputted address matches the one on the provided Proof of residence document.</li>
                <li>Where there is a mismatch, it should be accompanied by one of the following:</li>
                <ul class="sub-list">
                  <li>a) A letter from your employer (where applicable)</li>
                  <li>b) A birth certificate (if the property is in your parents' name)</li>
                  <li>c) Marriage Certificate (where the property is in the spouse's name)</li>
                  <li>d) An affidavit completed by the property owner (where the property is rented)</li>
                </ul>
                <li>The Identity documents should be valid and not expired.</li>
                <li>Submitted documents should be visible.</li>
              </ul>
            </div>
          </div>
          <p>{{ progress }}% Uploaded</p>
<!--          <button class="ui button purple fluid mt-4" :disabled="!isFormValid" type="submit">Submit Documents</button>-->
<!--          <button class="ui button grey fluid mt-4 mb-4" @click="back()">Back</button>-->

          <button class="ui button large basic purple fluid mt-4" :disabled="!isFormValid"
                  type="submit">Submit Documents</button>
          <button class="ui button large basic grey fluid mt-4 mb-4" @click="back()">Back</button>


        </form>
      </div>
    </div>
  </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";
import { useAuthStore } from '@/stores/auth';
import { useCustomerStore } from '@/stores/customer';
import { useAccountOpeningStore } from '@/stores/accountOpening';
import { InboxOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

export default {
  name: 'UploadDocuments',
  setup() {
    const authStore = useAuthStore();
    const customerStore = useCustomerStore();
    const accountOpeningStore = useAccountOpeningStore();
    return { authStore, customerStore, accountOpeningStore };
  },
  components: {
    InboxOutlined,
  },
  data() {
    return {
      documents: [
        {
          file: null,
          documentType: '',
          idNumber: null
        }
      ],
      customer: {
        mobileNumber: "",
        customerUid: ""
      },
      errors: {},
      operations: 0,
      isChecked: false,
      missingFile: '',
      progress: 0,
      model: {
        // list of objs
        files: [],
        fileTypes: [],
      },
      tmpFileType: "",
      showFileUploader: false,
      columns: [
        {
          title: "Type",
          dataIndex: "dataType",
          key: "dataType",
        },
      ],
      filePreviewUrl: null,
      fileType: null,
      showModal: false,
    };
  },
  mounted() {
    this.getDocumentTypes();
  },
  computed: {
    userId() { return this.authStore.userId; },
    phone() { return this.authStore.phone; },
    identityDocNo() { return this.customerStore.identityDocNo; },
    accountType() { return this.accountOpeningStore.accountType; },
    whenUploading() {
      return this.progress === 100;
    },
    isFormValid() {
      return this.validateFileUpload() && this.isChecked;
    },
    areFilesUploadedValid() {
      return this.validateFileUpload();
    }
  },
  methods: {
    uploadFilesSSO() {
      const formData = new FormData();
      const documents = [];

      // Construct documents array without the file
      this.model.files.forEach((file) => {
        documents.push({
          documentType: file.docType,
          idNumber: this.identityDocNo,
          userId: this.userId
        });
      });

      // Append documents JSON as a single part
      formData.append('documents', new Blob([JSON.stringify(documents)], { type: 'application/json' }));

      // Append each file separately
      this.model.files.forEach((file) => {
        formData.append(`files`, file.file);
      });

      fetch(`${import.meta.env.VITE_UNIVERSAL_ACCOUNT_OPENING_URL}/account-opening/document/upload`, {
        method: 'POST',
        body: formData
      }).then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          return res.json().then(() => {
            message.error('An error occurred while uploading the documents.');
            throw new Error('Upload error');
          });
        }
      }).then(() => {
        this.progress = 100;
        message.success('Documents uploaded successfully!');
        this.$router.push('/omni/payment');
      }).catch(() => {
        message.error('A network error occurred while uploading the documents.');
      });
    },

    async uploadArrayFilesSSO() {
      const total = this.model.files.length;
      let count = 0;
      let hasError = false;

      this.addOp();

      for (const file of this.model.files) {
        const formData = new FormData();

        formData.append('File', file.file, file.name);
        formData.append('UserId', this.userId);
        formData.append('DocumentLabel', file.docType);
        formData.append('IdNumber', this.identityDocNo);

        try {
          const res = await fetch(`${import.meta.env.VITE_UNIVERSAL_ACCOUNT_OPENING_URL}/account-opening/document/upload`, {
            method: 'POST',
            body: formData
          });

          if (!res.ok) {
            const errorData = await res.json();
            throw new Error(errorData.message || 'Upload error');
          }

          const data = await res.json();
          if (data.success) {
            count++;
            this.progress = (count / total) * 100;
          } else {
            hasError = true;
            message.error(`Failed to upload ${file.docType}.`);
          }
        } catch (error) {
          hasError = true;
          message.error(`Failed to upload ${file.docType}: ${error.message}`);
        }
      }

      this.removeOp();

      if (!hasError && count === total) {
        message.success('All documents uploaded successfully!');
        this.$router.push('/omni/payment');
      } else if (count > 0) {
        message.warning('Some documents failed to upload. Please retry.');
      }
    }

    ,
    validateFileUpload() {
      if (!this.model.fileTypes || this.model.fileTypes.length === 0) {
        this.missingFile = '';
        return false;
      }

      // Get all uploaded document types directly from the files array
      const uploadedDocTypes = this.model.files.map(file => file.docType);

      // Check if all required document types have been uploaded
      for (const fileType of this.model.fileTypes) {
        if (!uploadedDocTypes.includes(fileType.label)) {
          this.missingFile = `Please upload your ${fileType.name}.`;
          return false;
        }
      }

      this.missingFile = '';
      return true;
    },
    removeItem(item) {
      const index = this.model.files.indexOf(item);
      if (index > -1) {
        this.model.files.splice(index, 1);
      }
      this.showFileUploader = true;
    },
    startImageUpload(item) {
      this.tmpFileType = item;
      this.showFileUploader = true;
    },
    cancel() {
      this.model.files = null;
    },
    storeImageUpload() {
      // File is already added in beforeUpload
      this.showFileUploader = false;
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Document must be smaller than 2MB!");
        return false;
      }

      let newFile = {};
      newFile.file = file;
      newFile.docType = this.tmpFileType;

      this.model.files.push(newFile);
      return false;
    },
    getCustomerById() {
      http.getIdentity(URLS.customerByPhone + this.phone).then((res) => {
        this.customer.customerUid = res.body.uid;
      });
    },
    getDocumentTypes() {
      this.getNoAuthAndNoBaseUrl('/account-opening/document-types/account-types/' + this.accountType).then((res) => {
        if (res.success) {
          this.model.fileTypes = res.body;
        }
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.fileType = file.type;
      this.filePreviewUrl = URL.createObjectURL(file);
    },
    isPdf(fileType) {
      return fileType === 'application/pdf';
    },
    isImage(fileType) {
      return fileType.startsWith('image/');
    },
    showModalD(file) {
      this.fileType = file.type;
      this.filePreviewUrl = URL.createObjectURL(file);
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    next() { },
    back() {
      this.$router.push("/omni/customer-details");
    },
    ...baseMethods,
  }
};
</script>

<style scoped>
.document-form {
  margin-bottom: 20px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 500px;
  width: 100%;
  text-align: center;
}
</style>
